// Module
var code = "<dynamic-modal [id]=\"id\" [showFooter]=\"false\" (closed)=\"closed()\"> <div dynamic-modal-header [custom-label]=\"title\"></div> <div dynamic-modal-body> <action-group-list-dialog-content *ngIf=\"visible\" [template]=\"template\"></action-group-list-dialog-content> </div> </dynamic-modal>";
// Exports
module.exports = code;